export const IS_DEVELOPMENT = globalThis.location.hostname === "localhost";
export const IS_NOT_PRODUCTION = IS_DEVELOPMENT;
export const IS_PRODUCTION = !IS_DEVELOPMENT;

const userAgent = navigator.userAgent.toLowerCase();

export const LOAD_ERROR_MESSAGE =
  "Error loading Rates Visualizer. Please try again.";

// TABLET DETECTION - https://stackoverflow.com/a/50195587/6410635
export const IS_TABLET =
  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    userAgent,
  );
export const IS_COMPUTER_WIDTH = globalThis.innerWidth >= 960;

export const IS_MOBILE_PHONE: boolean = (() => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return !!toMatchItem.exec(globalThis.navigator.userAgent);
  });
})();

// BROWSER DETECTION - https://stackoverflow.com/a/26358856/6410635 - in use
// const IS_FIREFOX = userAgent.indexOf("firefox") !== -1;
// const IS_SAFARI = userAgent.indexOf("safari") !== -1;
// const IS_CHROME = userAgent.indexOf("chrome") !== -1;

export const KEYCODE_ESC = "Escape";

export const DEGREE_SYMBOL = "°";
